import React from "react";

const MailingsLower = () => {
    return (
        <div className="lower-container">
            <h1>MailingsLower</h1>
        </div>
    )
}

export default MailingsLower